/* Spares collection: details modal, quantity add-to-basket, spare search. */

$(document).ready(function () {
	// Re-apply the search term after facet AJAX re-renders replace the grid,
	// and load any further pages of the (re-)rendered result set.
	const grid = document.getElementById('product-grid');
	if (grid) {
		new MutationObserver(function () {
			applySpareSearch($('.spares-search-input').val());
			loadRemainingSpares();
		}).observe(grid, { childList: true });
	}
	loadRemainingSpares();
});

/*
	The spares page shows every result on one long page. Shopify renders at
	most 250 products per request, so fetch the remaining pages and append
	them to the grid, then hide the pagination links (which remain as the
	no-JS fallback). Re-run on every facet re-render; the params key aborts a
	stale loop when the filters change mid-load.
*/
let spareAutoloadKey = null;

function loadRemainingSpares() {
	const grid = document.getElementById('product-grid');
	if (!grid || !grid.classList.contains('spares-grid')) return;

	const params = new URLSearchParams(window.location.search);
	const startPage = parseInt(params.get('page') || '1', 10) || 1;
	params.delete('page');
	const key = params.toString();
	if (spareAutoloadKey === key) return;
	spareAutoloadKey = key;

	const $pagination = $('.pagination');
	if (!$pagination.length || !$pagination.html().trim()) return;

	let page = startPage + 1;

	function appendNext() {
		if (spareAutoloadKey !== key) return;
		const pageParams = new URLSearchParams(params);
		pageParams.set('page', page);
		fetch(window.location.pathname + '?' + pageParams.toString())
			.then(function (response) {
				return response.text();
			})
			.then(function (responseText) {
				if (spareAutoloadKey !== key) return;
				const doc = new DOMParser().parseFromString(responseText, 'text/html');
				const newGrid = doc.getElementById('product-grid');
				if (!newGrid || !newGrid.querySelector('.spare-item')) {
					$pagination.hide();
					return;
				}

				const children = Array.from(newGrid.children);

				// A group that continues across the page boundary re-renders its
				// heading at the top of the next page; drop the duplicates.
				let checkSubheader = true;
				if (children[0] && children[0].classList.contains('spares-grid-header')) {
					const headers = grid.querySelectorAll('.spares-grid-header');
					const lastHeader = headers.length ? headers[headers.length - 1].textContent.trim() : '';
					if (children[0].textContent.trim() === lastHeader) {
						children.shift();
					} else {
						checkSubheader = false;
					}
				}
				if (checkSubheader && children[0] && children[0].classList.contains('spares-grid-subheader')) {
					const subheaders = grid.querySelectorAll('.spares-grid-subheader');
					const lastSubheader = subheaders.length ? subheaders[subheaders.length - 1].textContent.trim() : '';
					if (children[0].textContent.trim() === lastSubheader) {
						children.shift();
					} else {
						// Rendered as the first sub-heading under its (repeated) group
						// heading, but here it follows the previous page's rows.
						children[0].classList.remove('first-in-group');
					}
				}

				children.forEach(function (el) {
					if (el.classList && el.classList.contains('spares-grid-header')) {
						el.classList.add('not-first-group');
					}
					grid.appendChild(el);
				});
				$pagination.hide();

				if (typeof window.initFadeUpInView === 'function') {
					window.initFadeUpInView();
				}

				page++;
				appendNext();
			})
			.catch(function () {
				// Leave the pagination usable if a page failed to load.
				$pagination.show();
			});
	}

	appendNext();
}

$(document).on('input', '.spares-search-input', function () {
	// The desktop filter bar and the mobile filter panel each render their own
	// field, so keep them in step: only one of the two is visible at a time.
	$('.spares-search-input').not(this).val(this.value);
	applySpareSearch(this.value);
});

function applySpareSearch(term) {
	term = (term || '').trim().toLowerCase();
	let visibleCount = 0;

	$('#product-grid .spare-item').each(function () {
		const $item = $(this);
		const haystack = (
			($item.attr('data-spare-title') || '') +
			' ' +
			($item.attr('data-spare-finish') || '') +
			' ' +
			($item.attr('data-spare-sku') || '')
		).toLowerCase();
		const show = !term || haystack.indexOf(term) !== -1;
		$item.toggle(show);
		if (show) visibleCount++;
	});

	// Hide group/product headings that no longer have visible rows under them.
	const children = $('#product-grid').children().toArray();
	children.forEach(function (el, i) {
		const isHeader = el.classList.contains('spares-grid-header');
		const isSubheader = el.classList.contains('spares-grid-subheader');
		if (!isHeader && !isSubheader) return;

		let hasVisibleItem = false;
		for (let j = i + 1; j < children.length; j++) {
			const next = children[j];
			if (next.classList.contains('spares-grid-header')) break;
			if (isSubheader && next.classList.contains('spares-grid-subheader')) break;
			if (
				next.classList.contains('spare-item') &&
				next.style.display !== 'none'
			) {
				hasVisibleItem = true;
				break;
			}
		}
		$(el).toggle(hasVisibleItem);
	});

	$('.spares-grid-empty').prop('hidden', visibleCount > 0);
}

/* Warm the modal image while the user hovers/focuses a row: Speedsize serves
   uncached renders slowly (~2s TTFB), so starting the download on hover means
   the modal usually opens with the image already in the browser cache. */
$(document).on('mouseenter focusin', '.spare-item', function () {
	const $item = $(this);
	if ($item.data('sparePreloaded')) return;
	$item.data('sparePreloaded', true);
	($item.attr('data-spare-images') || '')
		.split('||')
		.filter(Boolean)
		.forEach(function (url) {
			new Image().src = url;
		});
});

/* Quantity picker (snippets/spare-qty-select.liquid): number input + custom
   options list. Everything is delegated so the rows appended by the
   pagination autoload and the modal's copy behave the same. */
function clampSpareQty(value) {
	let qty = parseInt(value, 10);
	if (!Number.isInteger(qty) || qty < 1) qty = 1;
	if (qty > 50) qty = 50;
	return qty;
}

function closeSpareQtyLists() {
	$('.spare-qty-select.is-open').each(function () {
		$(this).removeClass('is-open opens-up');
		$(this).find('.spare-qty-popover').prop('hidden', true);
		$(this).find('.spare-qty-toggle').attr('aria-expanded', 'false');
	});
}

function openSpareQtyList($select) {
	closeSpareQtyLists();

	const value = String(clampSpareQty($select.find('.spare-qty').val()));
	const $options = $select.find('.spare-qty-options');
	$options.find('.spare-qty-option').each(function () {
		$(this).attr(
			'aria-selected',
			$(this).attr('data-value') === value ? 'true' : 'false'
		);
	});

	// Open upwards when the list would run off the bottom of the viewport or
	// of its scroll container (the modal, or the grid container whose
	// overflow-x guard also makes it scroll vertically).
	const rect = $select[0].getBoundingClientRect();
	const $container = $select.closest('.spare-modal, .spares-grid-container');
	let limit = window.innerHeight;
	if ($container.length) {
		limit = Math.min(limit, $container[0].getBoundingClientRect().bottom);
	}
	const $popover = $select.find('.spare-qty-popover');
	$popover.prop('hidden', false);
	const listHeight = $popover.outerHeight();
	$select.toggleClass('opens-up', rect.bottom + listHeight > limit);

	$select.addClass('is-open');
	$select.find('.spare-qty-toggle').attr('aria-expanded', 'true');

	const $current = $options.find('[aria-selected="true"]').first();
	if ($current.length) {
		$options[0].scrollTop =
			$current[0].offsetTop -
			($options[0].clientHeight - $current[0].offsetHeight) / 2;
		$current.trigger('focus');
	}
}

function selectSpareQty($select, value) {
	$select.find('.spare-qty').val(clampSpareQty(value)).trigger('change');
	closeSpareQtyLists();
	$select.find('.spare-qty-toggle').trigger('focus');
}

$(document).on('click', '.spare-qty-toggle', function () {
	const $select = $(this).closest('.spare-qty-select');
	if ($select.hasClass('is-open')) {
		closeSpareQtyLists();
	} else {
		openSpareQtyList($select);
	}
});

$(document).on('click', '.spare-qty-option', function () {
	selectSpareQty($(this).closest('.spare-qty-select'), $(this).attr('data-value'));
});

$(document).on('keydown', '.spare-qty-options', function (e) {
	const $options = $(this).find('.spare-qty-option');
	const index = $options.index(document.activeElement);
	let next = -1;
	switch (e.key) {
		case 'ArrowDown':
			next = Math.min(index + 1, $options.length - 1);
			break;
		case 'ArrowUp':
			next = Math.max(index - 1, 0);
			break;
		case 'Home':
			next = 0;
			break;
		case 'End':
			next = $options.length - 1;
			break;
		case 'Enter':
		case ' ':
			e.preventDefault();
			if (index >= 0) {
				selectSpareQty(
					$(this).closest('.spare-qty-select'),
					$options.eq(index).attr('data-value')
				);
			}
			return;
		default:
			return;
	}
	e.preventDefault();
	$options.eq(next).trigger('focus');
});

// Typed values are kept within the 1–50 range the list offers.
$(document).on('change', '.spare-qty', function () {
	this.value = clampSpareQty(this.value);
});

// Close on a click anywhere else, or when focus leaves the picker (tabbing).
$(document).on('click', function (e) {
	if (!$(e.target).closest('.spare-qty-select').length) {
		closeSpareQtyLists();
	}
});

$(document).on('focusout', '.spare-qty-select', function (e) {
	if (e.relatedTarget && !this.contains(e.relatedTarget)) {
		closeSpareQtyLists();
	}
});

/* Details modal */
$(document).on('click', '.spare-details-trigger', function () {
	openSpareModal($(this).closest('.spare-item'));
});

/* The row's add-to-basket button opens the details modal (with the row's
   quantity carried over); the purchase happens from the modal's own button. */
$(document).on('click', '.spare-item .spare-add-to-basket', function () {
	const $item = $(this).closest('.spare-item');
	openSpareModal($item, $item.find('.spare-qty').val());
});

function openSpareModal($item, qty) {
	const $modal = $('#spare-modal');
	if (!$modal.length || !$item.length) return;

	// Name, finish and SKU each on their own line; the finish and SKU lines
	// are hidden when the spare has none.
	const title = $item.attr('data-spare-title') || '';
	const finish = $item.attr('data-spare-finish') || '';
	const sku = $item.attr('data-spare-sku') || '';
	$modal.find('.spare-modal-title').text(title);
	$modal.find('.spare-modal-finish').text(finish).prop('hidden', !finish);
	$modal.find('.spare-modal-sku').text(sku).prop('hidden', !sku);
	$modal.find('.spare-modal-price').text($item.attr('data-spare-price') || '');

	// Render specifications if the spare has any.
	const $specs = $modal.find('.spare-modal-specs');
	const $specsList = $modal.find('.spare-modal-specs-list').empty();
	let specs = [];
	try {
		specs = JSON.parse($item.attr('data-spare-specs') || '[]');
	} catch (e) {
		specs = [];
	}
	specs = specs.filter(function (spec) {
		return (
			spec &&
			spec.title &&
			spec.value &&
			spec.title !== 'null' &&
			spec.value !== 'null'
		);
	});
	if (specs.length) {
		specs.forEach(function (spec) {
			$specsList.append($('<li>', { text: spec.title + ': ' + spec.value }));
		});
		$specs.prop('hidden', false);
	} else {
		$specs.prop('hidden', true);
	}

	const $images = $modal.find('.spare-modal-images').empty();
	const imageUrls = ($item.attr('data-spare-images') || '')
		.split('||')
		.filter(Boolean);
	if (imageUrls.length) {
		imageUrls.forEach(function (url) {
			$images.append($('<img>', { src: url, alt: title }));
		});
	} else {
		// Product has no images: mirror the row thumbnail's placeholder graphic
		// rather than leaving the modal image area blank.
		$images.append($item.find('.spare-item-image').children().clone());
	}

	const $atb = $modal.find('.spare-modal-atb');
	$atb.attr({
		'variant-id': $item.attr('data-variant-id'),
		'data-variant-id': $item.attr('data-variant-id'),
		'data-handle': $item.attr('data-handle'),
		'data-price': $item.attr('data-price'),
		'data-rrp-price': $item.attr('data-rrp-price'),
	});
	$atb.prop('disabled', $item.attr('data-can-buy') !== 'true');
	$modal.find('.spare-modal-qty').val(clampSpareQty(qty));

	closeSpareQtyLists();
	$('.spare-modal-overlay').prop('hidden', false);
	$modal.prop('hidden', false).attr('aria-hidden', 'false');
	$('body').css('overflow', 'hidden');
	spareModalReturnFocus = document.activeElement;
	$modal.find('.spare-modal-close').trigger('focus');
}

let spareModalReturnFocus = null;

function closeSpareModal() {
	const $modal = $('#spare-modal');
	if (!$modal.length || $modal.prop('hidden')) return;
	closeSpareQtyLists();
	$modal.prop('hidden', true).attr('aria-hidden', 'true');
	$('.spare-modal-overlay').prop('hidden', true);
	$('body').css('overflow', '');
	if (spareModalReturnFocus) {
		$(spareModalReturnFocus).trigger('focus');
		spareModalReturnFocus = null;
	}
}

$(document).on('click', '.spare-modal-close, .spare-modal-overlay', closeSpareModal);
$(document).on('keydown', function (e) {
	if (e.key !== 'Escape') return;
	if (!$('#spare-image-fullscreen').prop('hidden')) {
		closeSpareImageFullscreen();
		return;
	}
	const $open = $('.spare-qty-select.is-open');
	if ($open.length) {
		closeSpareQtyLists();
		$open.find('.spare-qty-toggle').trigger('focus');
		return;
	}
	closeSpareModal();
});

/* Full-screen drawing (tablet and mobile only, where the modal image is
   small): tapping a modal image opens it edge to edge with a close button.
   Uses a larger Speedsize render than the 840px modal copy. */
let spareFullscreenReturnFocus = null;

$(document).on('click', '.spare-modal-images img', function () {
	if (!window.matchMedia('(max-width: 1023px)').matches) return;
	const $viewer = $('#spare-image-fullscreen');
	if (!$viewer.length) return;

	const src = ($(this).attr('src') || '').replace(/([?&])width=\d+/, '$1width=1600');
	$viewer.find('.spare-image-fullscreen-img').attr({ src: src, alt: $(this).attr('alt') || '' });

	// The image itself isn't focusable, so focus goes back to the modal's
	// close button, which is where it was when the modal opened.
	spareFullscreenReturnFocus = $('#spare-modal .spare-modal-close')[0] || null;
	$viewer.prop('hidden', false).attr('aria-hidden', 'false');
	$viewer.find('.spare-image-fullscreen-close').trigger('focus');
});

function closeSpareImageFullscreen() {
	const $viewer = $('#spare-image-fullscreen');
	if (!$viewer.length || $viewer.prop('hidden')) return;
	$viewer.prop('hidden', true).attr('aria-hidden', 'true');
	$viewer.find('.spare-image-fullscreen-img').removeAttr('src');
	if (spareFullscreenReturnFocus) {
		$(spareFullscreenReturnFocus).trigger('focus');
		spareFullscreenReturnFocus = null;
	}
}

$(document).on('click', '.spare-image-fullscreen-close', closeSpareImageFullscreen);

/* Add to basket with quantity — same CartJS flow as .mainaddtocart in theme.js.
   Only the modal's button adds to basket; the row buttons open the modal. */
$(document).on('click', '.spare-modal-atb', function () {
	const $btn = $(this);
	if ($btn.is(':disabled')) return;

	const variantid = $btn.attr('variant-id');
	const rrp_price = $btn.attr('data-rrp-price');
	const quantity = clampSpareQty(
		$btn.closest('.spare-item-buy-row, .spare-modal-buy').find('.spare-qty').val()
	);

	const localeRootUrl = window.localeRootUrl || '';
	const cartEndpoint = (localeRootUrl + '/cart.js').replace('//', '/');
	fetch(cartEndpoint)
		.then(function (response) {
			return response.json();
		})
		.then(function (cart) {
			const existingItem = cart.items.find(function (item) {
				return item.variant_id === parseInt(variantid);
			});

			const onSuccess = function (message) {
				return function () {
					closeSpareModal();
					$('#basket-panel').removeClass('empty-basket-panel');
					if (typeof openBasketPanel === 'function') {
						openBasketPanel();
					}
					if (typeof announceCartChange === 'function') {
						announceCartChange(message);
					}
					if (typeof updateBasketContent === 'function') {
						setTimeout(updateBasketContent, 100);
					}
				};
			};

			if (existingItem) {
				CartJS.updateItemById(
					variantid,
					existingItem.quantity + quantity,
					{ _rrp_price: rrp_price },
					{ success: onSuccess('Item quantity updated in cart') }
				);
			} else {
				CartJS.addItem(
					variantid,
					quantity,
					{ _rrp_price: rrp_price },
					{ success: onSuccess('Item added to cart') }
				);
			}
		});
});
